import React, { useState, useEffect, useContext } from "react";
import HeaderIdLoader from "./HeaderIdLoader";

export const WrapPageContext = React.createContext();

export const useTocHeaderQuery = query => {
	const { setTocHeadersQuery } = useContext(WrapPageContext);
	useEffect(() => {
		setTimeout(() => {
			setTocHeadersQuery(query);
		});
	}, [query]);
};

export const WrapPageContextProvider = ({
	currentPath,
	currentHash,
	children,
	fromNav,
}) => {
	const [isTocVisible, setTocVisibilty] = useState(false);
	const [headingNodes, setHeadingNodes] = useState([]);
	const [headersQuery, setHeadersQuery] = useState("h2,h3");
	const [forceUpdateTocVal, setForceUpdateTocVal] = useState(-1);

	const updateTocState = val => {
		setTocVisibilty(val);
	};

	const updateHeadingsQuery = val => {
		setHeadersQuery(val);
	};

	useEffect(() => {
		if (!fromNav) {
			setTocVisibilty(window.innerWidth > 1199);
		}
	}, [fromNav]);

	return (
		<WrapPageContext.Provider
			value={{
				isTocVisible: isTocVisible,
				setIsTocVisible: updateTocState,
				headingNodes: headingNodes,
				setHeadingNodes: setHeadingNodes,
				tocHeadersQuery: headersQuery,
				setTocHeadersQuery: updateHeadingsQuery,
				forceUpdateTocVal: forceUpdateTocVal,
				forceUpdateToc: () =>
					setForceUpdateTocVal(forceUpdateTocVal * -1),
			}}
		>
			<HeaderIdLoader currentPath={currentPath} currentHash={currentHash}>
				{children}
			</HeaderIdLoader>
		</WrapPageContext.Provider>
	);
};
